type Ok<R> = R extends { status: 200 | 201; data: infer D } ? D : never;
type RowOf<R> = Ok<R> extends { items: (infer Row)[] } ? Row : never;

/** The body of a successful response. Unwraps orval's { data, status } envelope. */
export function okData<R extends { status: number }>(response: R | undefined): Ok<R> | undefined {
  return response?.status === 200 || response?.status === 201
    ? (response as unknown as { data: Ok<R> }).data
    : undefined;
}

/** The items of a successful list response, or none yet. */
export function okItems<R extends { status: number }>(response: R | undefined): RowOf<R>[] {
  return (okData(response) as { items: RowOf<R>[] } | undefined)?.items ?? [];
}

/** A list query, in the shape RecordPage's useRows returns. */
export function listResult<
  Q extends { data?: { status: number }; isPending: boolean; isError: boolean },
>(query: Q) {
  const data = query.data as NonNullable<Q['data']> | undefined;
  return {
    rows: okItems(data),
    total: (okData(data) as { total: number } | undefined)?.total ?? 0,
    isPending: query.isPending,
    isError: query.isError,
  };
}
